<style lang="scss" src='./GwRing.scss' scoped></style>
<template src="./GwRing.html"></template>

<script>
import { inRange } from 'lodash';
import ApexChart from 'vue-apexcharts';

const getChartOptions = ({ formatter, labels, fnSize, txtColor, ringColor }) => {
  return {
            chart: {
              type: 'radialBar',
            },
            plotOptions: {
              radialBar: {
                startAngle: -145,
                endAngle: 145,
                dataLabels: {
                  value: {
                    offsetY: -20,
                    fontSize: fnSize + 'px',
                    fontWeight: 'bold',
                    color: txtColor,
                    formatter: formatter
                  },
                  name: { // Unit
                    fontSize: '18px',
                    color: txtColor,
                    fontWeight: '0',
                    offsetY: 20
                  },
                },
                track: {
                  background: "#e7e7e7",
                }
              },
            },
            fill: {
              colors: [ringColor],
              type: 'solid',
              opacity: 1,
            },
            labels: labels
          };
  };

export default {
  name: 'GwRing',
  components: {
    ApexChart,
  },
  props: {
    height: {
      required: true,
    },
    loading: {
      required: true,
    },
    ringData: {
      required: true,
    },
    noIcon:{
      required: false,
    },
    fontModify :{
      required: false,
    },
    min: {
      required: false,
    },
    max: {
      required: false,
    },
    type: {
      required: false,
    },
    showDailyTemp:{
      type: Boolean,
      default: false,
    },
  },
  data() {
    return ({
      ico_measurement: null,
      minAngle: 125,
      maxAngle: 414,
      chartOptions: getChartOptions({
        formatter: (val)=> {
                              return this.ringData ? this.ringData.currentValue : '';
                            },
        labels: [''],
        fnSize: '22',
        txtColor: '',
        ringColor: ''
      }),
      chartLoadingOptions: getChartOptions({
        formatter: (val)=> {
                              return 'Loading';
                            },
        labels: [''],
        fnSize: '14',
        txtColor: '#6D6D6D',
        ringColor: '#6D6D6D'
      }),
    });
  },
  computed: {
    fillChart: function () {
      if (this.ringData && this.ringData !== {}) {
        const { unit, alert } = this.ringData;
        const fill = this.getFillPercentage('currentValue');
        this.updateChartOptions({ unit, alert });
        return [fill];
      }
      return [0];
    },

    minThresholdAngle: function() {
      return this.getThresholdAngle('minThreshold');
    },
    minThresholdLineX: function() {
      return this.getThresholdLineX('minThreshold');
    },
    minThresholdPostitionTxtX: function() {
      return this.getThresholdPostitionTxtX(this.minThresholdAngle);
    },
    minThresholdPostitionTxtY: function() {
      return this.getThresholdPostitionTxtY(this.minThresholdAngle);
    },

    maxThresholdLineX: function() {
      return this.getThresholdLineX('maxThreshold');
    },
    maxThresholdAngle: function() {
      return this.getThresholdAngle('maxThreshold');
    },
    maxThresholdLineX: function() {
      return this.getThresholdLineX('maxThreshold');
    },
    maxThresholdPostitionTxtX: function() {
      return this.getThresholdPostitionTxtX(this.maxThresholdAngle);
    },
    maxThresholdPostitionTxtY: function() {
      return this.getThresholdPostitionTxtY(this.maxThresholdAngle);
    },

    
  },

  methods: {
    getThresholdLineX(thresholdField) {
      if (this.ringData && this.ringData !== {} ) {
        const angle = this.getThresholdAngle(thresholdField);
        if (inRange(angle, this.minAngle, 230)) {
          return 10;
        }
        return 10.5;
      }
    },
    getThresholdAngle(thresholdField) {
      if (this.ringData && this.ringData !== {} ) {
        const { minValue, maxValue } = this.ringData;
        const value = this.ringData[thresholdField];
        /**
         *  totalPoints         -----   maxAngle
         *  (value - minValue)  -----         X
         */
        const totalPoints = maxValue - minValue;
        const angle = (((value - minValue) * (this.maxAngle - this.minAngle)) / totalPoints) + this.minAngle;
        return angle < this.minAngle ? this.minAngle : (angle > this.maxAngle ? this.maxAngle : angle);
      }
    },

    getThresholdPostitionTxtX: function(value) {
      if (value !== null && value != "") {
        return (0.000000000228994 * Math.pow(value, 5)) - (0.000000311871 * Math.pow(value, 4)) + (0.000153561 * Math.pow(value, 3)) - (0.0329672 * Math.pow(value, 2)) + (3.0034328 * value) - 103.49486;
      }
      return 0;
    },
    getThresholdPostitionTxtY: function(value) {
      if (value !== null && value != "") {
        return -(0.00000000000612429 * Math.pow(value, 5)) - (0.0000000502711 * Math.pow(value, 4)) + (0.0000592571 * Math.pow(value, 3)) - (0.0221105 * Math.pow(value, 2)) + (3.0923328 * value) - (129.67848);
      }
      return 0;
    },

    getFillPercentage(ringDataField) {
      if (this.ringData && this.ringData !== {}) {
        const { minValue, maxValue } = this.ringData;
        const value = this.ringData[ringDataField];
        const totalPoints = maxValue - minValue;
        const fill = (value - minValue) * 100 / totalPoints;
        return fill;
      }
    },

    updateChartOptions({ unit, alert }) {
      this.setIcoMeasurement();

      let value = this.ringData 
                  ? ( this.ringData.currentValue % 1 == 0 
                      ? this.ringData.currentValue 
                      : Number((this.ringData.currentValue).toFixed(2)))
                  : '';

      this.chartOptions = getChartOptions({
        formatter: (val)=> {
                              return value !== undefined && value !== null && value !== '' ? value : '-';
                            },
        labels: [unit],
        fnSize: '22',
        txtColor: alert ? '#FF403D' : '#656565',
        ringColor: alert ? '#FF403D' : '#4EC550'
      });
    },

    async setIcoMeasurement() {
      const alertTypeValues = Object.values(this.consts.AlertType);
      const alertType = alertTypeValues.find((alertType) => alertType.key.toLowerCase() === this.ringData.key.toLowerCase())
      this.ico_measurement = await require(`@/assets/img/gw/alert/${alertType.id}.png`);
    }

  },

  beforeCreate() {},

  created() {},

  mounted() {
  },

  beforeDestroy() {
  },

  };

</script>
